'use client';

import React from 'react';
import Image from 'next/image';

interface TestimonialProps {
  quote: string;
  author: string;
  role: string;
  avatar: string;
}

function TestimonialCard({ quote, author, role, avatar }: TestimonialProps) {
  return (
    <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] animate-fade-in">
      <div className="flex flex-col h-full">
        <div className="flex-grow">
          <div className="text-4xl mb-4 text-primary-DEFAULT2">❝</div>
          <p className="text-gray-600 italic mb-6">{quote}</p>
        </div>
        <div className="flex items-center">
          <div className="w-12 h-12 rounded-full overflow-hidden">
            <Image
              src={avatar}
              alt={`${author}'s profile photo`}
              width={48}
              height={48}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="ml-4">
            <p className="font-semibold text-gray-900">{author}</p>
            <p className="text-sm text-gray-500">{role}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Testimonials() {
  const testimonials = [
    {
      quote: "The stories are so engaging and personalized. My son asks for them every night!",
      author: "Sarah M.",
      role: "Parent of 2",
      avatar: "/avatars/avatar-1.jpg"
    },
    {
      quote: "Finally, bedtime stories that teach valuable lessons while keeping my kids entertained.",
      author: "Michael P.",
      role: "Father of 3",
      avatar: "/avatars/avatar-2.jpg"
    },
    {
      quote: "The AI creates such magical stories. It's like having a professional storyteller at home.",
      author: "Emily R.",
      role: "Mother & Teacher",
      avatar: "/avatars/avatar-3.jpg"
    },
    {
      quote: "My daughter loves seeing herself as the main character. It's made bedtime so much easier!",
      author: "David K.",
      role: "Parent",
      avatar: "/avatars/avatar-4.jpg"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12 animate-fade-in">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold mb-4 bg-gradient-to-r from-[#FF8B6B] to-[#FF5D3A] bg-clip-text text-transparent">
            What Parents Are Saying
          </h2>
          <p className="text-lg text-gray-600">
            Join thousands of happy families creating magical bedtime moments
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div key={index} className={`animate-slide-up animation-delay-${index * 200}`}>
              <TestimonialCard
                quote={testimonial.quote}
                author={testimonial.author}
                role={testimonial.role}
                avatar={testimonial.avatar}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 